import type { FaireProductEntity } from "../../entity_types/product";

export const p_bt74uv2sv6: FaireProductEntity = {
  token: "p_bt74uv2sv6",
  type: "product",
  name: "348BK So Cozy Set",
  brandToken: "b_m84sdvbj3h",
  brandName: "AEMI + CO",
  imageUrl:
    "https://cdn.faire.com/fastly/358cc015ca2c6ab6173e3c040e9c8d033337391bbf2d47e58e2dd265740bfe5b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08a8f18f92d547825dcff97c61906ce3e152781d6e652d042844b6ff3bfbd5b9.jpeg",
    "https://cdn.faire.com/fastly/d38c9df2387ecf5b4174f6380b0a31fd5507aed161064ad283addca0056ccae4.jpeg",
    "https://cdn.faire.com/fastly/9b4f2dad2d798db3811d7355f45949318814ae6ee4662c620b61a45248f4ccad.jpeg",
    "https://cdn.faire.com/fastly/737858bfe7b016c8ae5ed8b7be59586dc410b2a24e49f5cbcd1d4e5ab5f39380.jpeg",
    "https://cdn.faire.com/fastly/bcc4bda104f3d4f7da90c53dc988df249cc73e1a9f8412fbe290e90ba6f85bd0.jpeg",
    "https://cdn.faire.com/fastly/4247cc54797d4df872ff4d11e98c90bf78a61658e6d4b0c0fdf078fdd7a10576.jpeg",
    "https://cdn.faire.com/fastly/ed54acecb49aba5e74efe53659a2844dea659391c2211dea8d24de4f691d98c6.jpeg",
    "https://cdn.faire.com/fastly/a8733fe452f111d606bec0e59637f012320897a7d766928bb7e845c2001500cc.jpeg",
    "https://cdn.faire.com/fastly/00761dd402c2e0e3d8fea5889602b163f837d052699810b5c3a472727aee323f.jpeg",
    "https://cdn.faire.com/fastly/54369d0bcf64ff007a14b6c56bcdd6f4eba5f3e75bb172441d969067de05221e.jpeg",
    "https://cdn.faire.com/fastly/fdbbfcbc8c1ddfcbaca9edb3c93f4d84a313547c9a0002695af3e11bca121940.jpeg",
    "https://cdn.faire.com/fastly/c7908f7ef667bb24ef72f093147e70aff2aecca6e6112fc6993171d9cf9bc2dd.jpeg",
  ],
  priceDollars: 12.95,
  description:
    "Sleep or lounge in style, and you will experience the most tranquil sensation against your skin in our So Cozy tank and short set.",
  tags: [],
  msrpDollars: 25.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:10.917Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
